import React from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ExtraTokenUsageChip = ({
  label,
  labelKey = 'settings.others.extra_token_usage',
  fallback = 'Extra token usage',
  sx = {}
}) => {
  const { t } = useTranslation();

  return (
    <Chip
      label={label || t(labelKey, fallback)}
      size="small"
      variant="outlined"
      color="warning"
      sx={{
        mb: 0.5,
        fontSize: '0.7rem',
        height: 22,
        ...sx
      }}
    />
  );
};

export default ExtraTokenUsageChip;
